const aiFailMessages = [
  {
    title: " I need a coffee break",
    message:
      "My brain just overheated thinking about your trip. Please try again in a minute ☕",
  },
  {
    title: " Too many thoughts at once",
    message:
      "I tried planning too many trips at the same time. Yours is important — try again shortly!",
  },
  {
    title: " Lost in imagination",
    message:
      "I traveled too far in my mind and got lost. Hit refresh and I’ll be back!",
  },
  {
    title: " Traffic jam in AI land",
    message:
      "Lots of travelers are using me right now. Let the traffic clear and try again.",
  },
  {
    title: " Brain.exe stopped working",
    message:
      "Don’t worry, I’ll reboot myself. Please try again in a moment!",
  },
];

export default aiFailMessages;
